import Component from "@glimmer/component";
import { pageTitle } from "ember-page-title";
import { LinkTo } from "@ember/routing";
import { Song } from "#app/models/song.ts";

export default class PlayErrorTemplateComponent extends Component {
  EMPTY_SONG_MODEL = {
    song: new Song({
      name: "Empty Song",
      tempo: 100,
      channels: [],
    }),
  };

  <template>
    {{pageTitle "Playing"}}
    <h1>Error</h1>
    <div>
      Could not decode song data from URL.
      <LinkTo
        @route="play.song"
        @model={{this.EMPTY_SONG_MODEL}}
        class="text-blue-500 hover:text-blue-600 underline"
      >
        Start with an empty song.
      </LinkTo>
    </div>
  </template>
}
